module.exports = __webpack_public_path__ + "img/pembukaan_tab.6c5c70e6.png";